import Axios from 'axios'

import { getWithRedirect } from 'utils/axios'
import { parseAuthenticationHeader } from 'helpers/Functions'

import { PostObjectSizeMappingBody } from 'types/GlobalNormalizedRent'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v2/customers`

export async function getObjectSizeMappings(customerId: string) {
  return getWithRedirect(`${URL}/${customerId}/object-size-mappings`)
}

export async function createObjectSizeMapping(
  customerId: string,
  body: PostObjectSizeMappingBody
) {
  return Axios.post(
    `${URL}/${customerId}/object-size-mappings`,
    { data: body },
    parseAuthenticationHeader()
  )
}

export async function deleteObjectSizeMapping(
  customerId: string,
  mappingId: string
) {
  return Axios.delete(
    `${URL}/${customerId}/object-size-mappings/${mappingId}`,
    parseAuthenticationHeader()
  )
}
